/* RESPONSIBLE TEAM: team-workflows */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { type Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import { hash } from 'rsvp';
import { taskFor } from 'ember-concurrency-ts';
import type ReportingMetrics from 'embercom/services/reporting-metrics';

class AutomationFinAIAgentAICategoriesRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;
  @service declare reportingMetrics: ReportingMetrics;

  reactEnabled() {
    return true;
  }

  async beforeModel() {
    if (!this.appService.app.canUseFinFirstAiCategories) {
      return this.router.transitionTo('apps.app.automation.fin-ai-agent.setup');
    }
    await taskFor(this.reportingMetrics.setup).perform();
    return hash({});
  }
}
export default ReactRoute(AutomationFinAIAgentAICategoriesRoute, { overrideRenderTemplate: false });
